export default {
  displaySearchResults: false,
  searchType: undefined,
  searchResults: [],
  moreSearchResults: false,
  searchHistory: []
};
